<template>
    <div>
        <es-title title="Processamento de Cobrança de Clientes">
            <template #right>
                <div v-if="tab == 0" class="button is-danger" @click="toggleModalImportacao">Importar Arquivo Excel
                </div>
            </template>
        </es-title>

        <!--importação -->
        <es-modal title="Importação de Arquivo Excel" :config="modalImportacao">
            <div class="field">
                <div class="file is-centered is-boxed is-success has-name">
                    <label class="file-label">
                        <input class="file-input" type="file" @change="importacaoExcel" accept=".xlsx,.xls">
                        <span class="file-cta">
                            <span class="file-icon">
                                <i class="fas fa-upload"></i>
                            </span>
                            <span class="file-label">
                                Selecionar arquivo de dados de clientes
                            </span>
                        </span>
                    </label>
                </div>
            </div>

            <div class="field">
                <button class="button is-success" :disabled="!arquivoSelecionado" @click="processar">Iniciar
                    Processamento</button>
            </div>
        </es-modal>

        <hr style="margin: 40px 0; border-top: 2px solid #ccc;" />

        <es-title title="Resultado do Processamento">
            <template #right>
                <div v-if="tab == 0" class="button is-danger" @click="visualizarResultados">Visualizar Resultados</div>
            </template>
        </es-title>
        <div v-if="imagemGraficoBase64" class="grafico">
            <img :src="'data:image/png;base64,' + imagemGraficoBase64" alt="Gráfico de Indicadores" />
        </div>

    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            tab: 0,
            arquivoSelecionado: null,
            indicadores: [],
            modalImportacao: {
                active: false
            },
            imagemGraficoBase64: null,
            graficoBase64: null
        };
    },
    methods: {
        toggleModalImportacao() {
            this.modalImportacao.active = !this.modalImportacao.active;
        },

        importacaoExcel(event) {
            const file = event.target.files[0];
            if (file) {
                this.arquivoSelecionado = file;
            } else {
                this.arquivoSelecionado = null;
            }
        },

        async processar() {
            if (!this.arquivoSelecionado) return;

            const formData = new FormData();
            formData.append('arquivo', this.arquivoSelecionado);

            try {
                const response = await axios.post('api/v1/batimento/processar_cobranca/importacao', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                this.imagemGraficoBase64 = response.data.grafico_base64; 
                this.modalImportacao.active = false;
            } catch (err) {
                console.error('Erro ao processar o arquivo', err);
            }
        },

        visualizarResultados() {
            if (this.imagemGraficoBase64) {
                this.graficoBase64 = this.imagemGraficoBase64;
            } else {
                alert("Nenhum gráfico disponível. Primeiro processe o arquivo.");
            }
        }


    }
};
</script>

<style lang="scss">
.button.is-success {
    background-color: #23d160;
    border-color: #23d160;
}

.file-cta {
    background-color: #23d160;
    color: white;
}

.file-name {
    margin-left: 10px;
}

.modal-background {
    background-color: rgba(10, 10, 10, 0.21) !important;
}

.file {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
}

.file-label {
    width: 100%;
}

.file-input {
    width: 100%;
}

.file-cta {
    width: 100%;
}

.file-name {
    width: 100%;
    text-align: left;
}

.button.is-success {
    margin-top: 20px;
}

@media screen and (max-width: 768px) {
    .file {
        max-width: 90%;
    }
}
</style>